import { supabase } from "@/integrations/supabase/client";
import { getFacultyGroup } from "@/lib/faculty-groups";

export type FeedbackSignalType = "confusion" | "positive" | "re_read";
export type FeedbackSignalSource = "feedback" | "test_wrong" | "re_read";

export type FeedbackSignalInput = {
  studentId: string;
  resourceId: string;
  signalType: FeedbackSignalType;
  source: FeedbackSignalSource;
  subjectTag?: string | null;
  chapterTag?: string | null;
  faculty?: string | null;
  rawFeedback?: string | null;
};

export async function createSignal(input: FeedbackSignalInput): Promise<void> {
  try {
    const facultyGroup = input.faculty ? getFacultyGroup(input.faculty) : null;
    await supabase.from("resource_feedback_signals").insert({
      student_id: input.studentId,
      resource_id: input.resourceId,
      signal_type: input.signalType,
      source: input.source,
      subject_tag: input.subjectTag ?? null,
      chapter_tag: input.chapterTag ?? null,
      faculty_group: facultyGroup,
      raw_feedback: input.rawFeedback ?? null,
    });
  } catch {
    // Silent by design
  }
}
